import { parseIncomeYen } from '../spouseSection/spouseEligibility';
import type { TaxSpecialStatusApi } from '../taxDeclarationApi';
import { boolToYn } from './specialStatusEligibility';
import type { SpecialStatusSnapshot } from './specialStatusTypes';
import { emptySpecialStatus } from './specialStatusTypes';

export function specialStatusFromApi(raw: TaxSpecialStatusApi | null | undefined): SpecialStatusSnapshot {
  if (!raw) return emptySpecialStatus();
  const incomeStr = (v: number | string | null | undefined) => {
    if (v == null) return '';
    if (typeof v === 'number') return String(Math.trunc(v));
    return v.trim().replace(/,/g, '');
  };
  return {
    singleParentChildEmpFamilyId: raw.singleParentChildEmpFamilyId ?? null,
    singleParentChildRelationship: raw.singleParentChildRelationship?.trim() ?? '',
    singleParentChildConfirmed: boolToYn(raw.singleParentChildConfirmed),
    singleParentClaimedByOther: boolToYn(raw.singleParentClaimedByOther),
    singleParentOutcome: (raw.singleParentOutcome?.trim() as SpecialStatusSnapshot['singleParentOutcome']) ?? '',
    widowSpouseLost: (raw.widowSpouseLost?.trim() as SpecialStatusSnapshot['widowSpouseLost']) ?? '',
    widowCurrentlyRemarried: boolToYn(raw.widowCurrentlyRemarried),
    widowOutcome: (raw.widowOutcome?.trim() as SpecialStatusSnapshot['widowOutcome']) ?? '',
    workingStudentEnrolled: boolToYn(raw.workingStudentEnrolled),
    workingStudentSchoolType:
      (raw.workingStudentSchoolType?.trim() as SpecialStatusSnapshot['workingStudentSchoolType']) ?? '',
    workingStudentSalaryOnly: boolToYn(raw.workingStudentSalaryOnly),
    workingStudentSalaryRevenue: incomeStr(raw.workingStudentSalaryRevenue),
    workingStudentHasNonEmploymentIncome: boolToYn(raw.workingStudentHasNonEmploymentIncome),
    workingStudentNonEmploymentIncome: incomeStr(raw.workingStudentNonEmploymentIncome),
    workingStudentOutcome: (raw.workingStudentOutcome?.trim() as SpecialStatusSnapshot['workingStudentOutcome']) ?? '',
    disabilityWsChangedDuringYear: boolToYn(raw.disabilityWorkingStudentChangedDuringYear),
    disabilityWsChangeDate: raw.disabilityWorkingStudentChangeDate?.trim() ?? '',
  };
}

export function specialStatusToApi(snap: SpecialStatusSnapshot): TaxSpecialStatusApi {
  const yn = (v: string): boolean | null => {
    if (v === 'yes') return true;
    if (v === 'no') return false;
    return null;
  };
  const income = (raw: string): number | null => {
    const n = parseIncomeYen(raw);
    return n > 0 ? n : null;
  };
  const str = (v: string): string | null => (v.trim() ? v.trim() : null);
  return {
    singleParentChildEmpFamilyId: snap.singleParentChildEmpFamilyId,
    singleParentChildRelationship: str(snap.singleParentChildRelationship),
    singleParentChildConfirmed: yn(snap.singleParentChildConfirmed),
    singleParentClaimedByOther: yn(snap.singleParentClaimedByOther),
    singleParentOutcome: str(snap.singleParentOutcome),
    widowSpouseLost: str(snap.widowSpouseLost),
    widowCurrentlyRemarried: yn(snap.widowCurrentlyRemarried),
    widowOutcome: str(snap.widowOutcome),
    workingStudentEnrolled: yn(snap.workingStudentEnrolled),
    workingStudentSchoolType: str(snap.workingStudentSchoolType),
    workingStudentSalaryOnly: yn(snap.workingStudentSalaryOnly),
    workingStudentSalaryRevenue: income(snap.workingStudentSalaryRevenue),
    workingStudentHasNonEmploymentIncome: yn(snap.workingStudentHasNonEmploymentIncome),
    workingStudentNonEmploymentIncome: income(snap.workingStudentNonEmploymentIncome),
    workingStudentOutcome: str(snap.workingStudentOutcome),
    disabilityWorkingStudentChangedDuringYear: yn(snap.disabilityWsChangedDuringYear),
    disabilityWorkingStudentChangeDate:
      snap.disabilityWsChangedDuringYear === 'yes' ? str(snap.disabilityWsChangeDate) : null,
  };
}
